

const projects = [
    {
      key: 1,
      title: "NewsApp",
      content:
        "created using React, ALan Ai, it is a news app that uses newsAPI to search for news and is fully voice controlled",
        
        image:"./images/news.jpeg",
        github:"https://github.com/Parthkhandelwal0/Voice_controlled_NewsApp",
        website: "https://voiceassistantnewsapp.netlify.app/"
    },
    {
      key: 2,
      title: "KeepNotes",
      content:
        "A Google Keep Notes clone created using html, css, REACT and materialUI which allows you to add or delete notes",
        image:"./images/keepnotes2.png",
        github:"https://github.com/Parthkhandelwal0/KeepNotes",
        website:""

    },
    {
      key: 3,
      title: "BlogSite",
      content:
        "a blog website to write about stuff that excites you uses NodeJs, Mongodb, Mongoose,Express, Bootsrap, HTML, CSS",
        image:"./images/blog3.jpg",
        github:"https://github.com/Parthkhandelwal0/Blogwebsite",
        website:"https://dailyjournal10.herokuapp.com/"
    },
    {
      key: 4,
      title: "Covid19 live",
      content:
        "a project to track infected, recovered and total death caused by COVID-19, uses html, css,React.js, Material UI,chart.js",
        image:"./images/COVID19.png",
        github:"https://github.com/Parthkhandelwal0/COVID-19",
        website:"https://covid-19-54791.web.app/"

    }
  ];

export default projects;